import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { SmoothScroll } from './components/SmoothScroll';
import App from './App';
import './i18n';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="min-h-screen bg-[#0D0907]" />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SmoothScroll options={{ duration: 1.2, multiplier: 0.8 }}>
            <App />
          </SmoothScroll>
        </BrowserRouter>
      </QueryClientProvider>
    </Suspense>
  </StrictMode>
);
